import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import {
  PaginatorService,
  SimplePaginator
} from "../../../core/services/paginator.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { Output } from "@angular/core";
@Component({
    selector: "app-smartfleet-paginator",
    templateUrl: "./paginator.component.html",
    styleUrls: ["./paginator.component.scss"],
    standalone: false
})
export class PaginatorComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @Input() dataSource: MatTableDataSource<any>;
  @Input() modelName: string;
  @Input() pageSizeOptions: Array<number>;
  @Input() paginationInServer: boolean;
  @Input() length: number;
  @Input() hidePageSize = false;

  @Output() pageChange: any = new EventEmitter<SimplePaginator>();
  @Output() pageChangePagination: any = new EventEmitter<SimplePaginator>();

  public pageSize = 0;
  public pageIndex = 0;
  private unsub$ = new Subject();
  private allItems: SimplePaginator[] = [];
  private localStorageName = "";

  constructor(private paginatorService: PaginatorService) {}

  ngOnInit(): void {
    this.localStorageName = this.modelName + "-pageSize";

    if (!this.pageSizeOptions) {
      this.pageSizeOptions = this.paginatorService.pageSizeOptions;
    }

    this.pageSize = this.getPageSizeFromLocalStorage();

    setTimeout(() => {
      this.paginatorService.paginatorModel
        .pipe(takeUntil(this.unsub$))
        .subscribe((res) => {
          this.allItems = res;
          const paginator = res.find(
            (item) => item.modelName === this.modelName
          );
          if (paginator) {
            this.pageIndex = paginator.pageIndex;
            this.pageSize = paginator.pageSize;
          }
        });
    }, 200);
  }

  goToFirstPage() {
    this.paginator.firstPage();
  }

  ngAfterViewInit() {
    if (this.paginationInServer != true) {
      this.dataSource.paginator = this.paginator;
    }
  }

  ngOnDestroy() {
    this.unsub$.next("");
    this.unsub$.complete();
  }

  onPageChange(pageEvent: PageEvent): void {
    const obj: SimplePaginator = {
      modelName: this.modelName,
      pageIndex: pageEvent.pageIndex,
      pageSize: pageEvent.pageSize
    };

    this.setPageSizeToLocalStorage(pageEvent.pageSize);

    if (this.paginationInServer != true) {
      const index = this.allItems.findIndex(
        (item) => item.modelName === this.modelName
      );
      if (index === -1) {
        this.allItems.push(obj);
      } else {
        this.allItems[index] = obj;
      }
      this.paginatorService.setPaginatorModel(this.allItems);
    }
    this.pageChange.emit(obj);
  }

  private getPageSizeFromLocalStorage(): number {
    return +localStorage.getItem(this.localStorageName);
  }

  private setPageSizeToLocalStorage(pageSize: number): void {
    localStorage.setItem(this.localStorageName, pageSize.toString());
  }
}
